export const SITE = {
  headerLogo: 'header-logo-link',
  navReviews: 'header-nav-reviews',
  navUseCases: 'header-nav-usecases',
  navGuides: 'header-nav-guides',
  navComparison: 'header-nav-comparison',
  navResources: 'header-nav-resources',
  navAbout: 'header-nav-about',
  mobileMenuTrigger: 'header-mobile-menu-trigger',
  headerCta: 'header-cta-button',
  footerPrivacy: 'footer-privacy-link',
  footerDisclosure: 'footer-disclosure-link',
  footerNewsletterInput: 'footer-newsletter-input',
  footerNewsletterSubmit: 'footer-newsletter-submit',
};

export const OPTIN = {
  emailInput: 'optin-email-input',
  nameInput: 'optin-name-input',
  submitButton: 'optin-submit-button',
};

export const HOME_PAGE = {
  heroEmailInput: 'home-hero-email-input',
  heroSubmit: 'home-hero-submit',
  heroVideoPlay: 'home-hero-video-play',
  comparisonTable: 'home-comparison-table',
  caseCard: (slug) => `home-usecase-card-${slug}`,
  faqItem: (i) => `home-faq-item-${i}`,
};

export const REVIEW_PAGE = {
  affiliateCta: (slug) => `review-affiliate-cta-${slug}`,
  tocLink: (i) => `review-toc-link-${i}`,
  card: (slug) => `review-card-${slug}`,
};

export const COMPARISON_PAGE = {
  sortSelect: 'comparison-sort-select',
  filterTab: (id) => `comparison-filter-${id}`,
  row: (slug) => `comparison-row-${slug}`,
  tryCta: (slug) => `comparison-try-cta-${slug}`,
};

export const RESOURCES_PAGE = {
  promptItem: (i) => `resources-prompt-item-${i}`,
};
